module.exports = __webpack_public_path__ + "static_wap/img/logo.5357d14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo.png
// module id = Vpqn
// module chunks = 1